export const standard = 0;
export const gabarit = 1;
